<template>
  <SectionContainerPage>
    <SectionCategoryList
      xs12
      :categoryList="categoryList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Category',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewCategoryClicked',
        },
      ]"
      @onAddNewCategoryClicked="showDialogFormCategoryAdd = true"
      @onEditCategoryClicked="
        (val) => [
          (categoryToEdit = val.categoryToEdit),
          (showDialogFormCategoryEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormCategoryAdd
      :showDialog="showDialogFormCategoryAdd"
      @onCancelClicked="showDialogFormCategoryAdd = false"
      @onSubmitClicked="(val) => [onDialogFormCategoryAddSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormCategoryEdit
      :showDialog="showDialogFormCategoryEdit"
      :categoryToEdit="categoryToEdit"
      @onCancelClicked="showDialogFormCategoryEdit = false"
      @onSubmitClicked="(val) => [onDialogFormCategoryEditSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionCategoryList from './sections/SectionCategoryList'
import DialogFormCategoryAdd from '../dialogs/DialogFormCategoryAdd'
import DialogFormCategoryEdit from '../dialogs/DialogFormCategoryEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionCategoryList,
    DialogFormCategoryAdd,
    DialogFormCategoryEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormCategoryAdd: false,
    showDialogFormCategoryEdit: false,
    categoryList: [],
    categoryToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormCategoryAddSubmit(data) {
      this.isLoadingCount++
      this._insertCategory({
        name: data.name,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormCategoryAdd = false
          this.fetchLists()
          this.$emit('notify', { message: 'Category successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormCategoryEditSubmit(data) {
      this.isLoadingCount++
      this._updateCategory({
        id: data.id,
        name: data.name,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormCategoryEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'Category successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Category'],
        successCb: (data) => {
          this.isLoadingCount--
          this.categoryList = data.categories
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.categoryList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
